import classNames from 'classnames'
import { Resizable } from 're-resizable'
import React from 'react'

import { Spinner } from '../spinner/spinner.js'

export interface ValidationProps {
    title: string
    subtitle: string
    loadingText: string
    iframeKey?: string
    iframeUrl?: string
    isLoading?: boolean
}

export const ValidationStep = (props: ValidationProps): JSX.Element => {
    const className: string = classNames('validation-step', props.isLoading && 'is-loading')
    const { title, subtitle, loadingText, iframeKey, iframeUrl, isLoading } = props
    const defaultSize = {
        width: '100%',
        height: 720,
    }

    return (
        <div className={className}>
            <div className="text">
                <h3>{title}</h3>
                {!isLoading && <p>{subtitle}</p>}
                {isLoading && (
                    <>
                        <p>{loadingText}</p>
                        <Spinner height={200} size="medium" />
                    </>
                )}
            </div>
            {!isLoading && iframeUrl && (
                <div className="validation-step__iframe-wrapper">
                    <Resizable defaultSize={defaultSize} minHeight={600} minWidth="100%" maxWidth="100%">
                        <iframe key={iframeKey} src={iframeUrl} className="validation-step__iframe" />
                    </Resizable>
                </div>
            )}
        </div>
    )
}
